import { myListsDetailsOptionsStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsOptions";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import ChevronsUpDown from "@insite/mobius/Icons/ChevronsUpDown";
import Search from "@insite/mobius/Icons/Search";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

myListsDetailsOptionsStyles.sortByOverflowMenu = {
    iconProps: { 
        src: ChevronsUpDown
    },
    cssOverrides:{
        wrapper:css`
            span {
                color: #FFFFFF !important;
            }
            ul {
                background: #FFFFFF !important;
            }
        `,
    }
}

myListsDetailsOptionsStyles.productSelectorStyles = {
    selectButton:{
        css:css`
            margin-top: 30px;
            span {
                font-size: 12px;
                font-weight: 600;
                letter-spacing: 2px;
                line-height: normal;
                text-align: center;
                color: #ffffff;
                text-transform: uppercase;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            width: 100%;
                        `,
                    ],
                    "max",
                )}
            `,
    },
    searchDynamicDropdown:{
        cssOverrides:{
            list:css`
                background: #FFFFFF !important;
            `,
        }
    }
}

myListsDetailsOptionsStyles.search = {
    iconProps: { src: Search},
    cssOverrides:{
        formInputWrapper:css`
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        span {
                            right: 20px !important;
                        }
                        input {
                            width: 96% !important;
                        }
                    `,
                    css`
                        span {
                            right: 20px !important;
                        }
                        input {
                            width: 96% !important;
                        }
                    `,
                    null,
                    null,
                    null
                ]
            )}
        `,
        
    }
}